import {ResponsibleGamingIconsDefaultBox} from "./responsible-gaming-icons.default.box";

export const ResponsibleGamingIconsBox = ResponsibleGamingIconsDefaultBox;
